import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Colton Wiscombe
 * id DBAC0B3F-A11E-4BFF-B5A5-802C28802CFC
 * name card-minus-outline
 * version: 5.6.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/card-minus-outline.svg
 * tags
 */
export const CardMinusOutlineIcon = createSvgIcon(<><path d="M23 18V20H15V18H23M13.09 18H4V6H20V13.09C20.72 13.21 21.39 13.46 22 13.81V6C22 4.89 21.11 4 20 4H4C2.9 4 2 4.89 2 6V18C2 19.11 2.9 20 4 20H13.09C13.04 19.67 13 19.34 13 19C13 18.66 13.04 18.33 13.09 18Z" /></>, 'CardMinusOutlineIcon');
export default CardMinusOutlineIcon